import { useRepositoryMutation } from '@mews-commander/data-access';
import { LocalizedText, showSuccessAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const useRatesDelete = () =>
    useRepositoryMutation('portfolioRates', 'delete', {
        invalidateQueries: {
            rateGroups: ['getOverviewEntries', 'getAll'],
            rates: ['getOverviewEntries'],
        },
        onSuccess: (_, params) => {
            showSuccessAlert({
                title: (
                    <LocalizedText
                        textKey={TextKey.RateGroupRateDeleteSuccessMessage}
                        substitutes={{ count: params.rateIds.length }}
                    />
                ),
            });
        },
    });
